import { useState } from 'react'
import { FLAG_OPTIONS } from '../../../utils/flagOptions'

/**
 * Modal multi-select de banderas para include/exclude filtros.
 * @param {'include'|'exclude'} mode
 * @param {string[]} initialSelected - flag keys ya seleccionados
 * @param {Function} onConfirm - (keys: string[]) => void
 * @param {Function} onClose - () => void
 */
export default function IncludeExcludeFlagModal({ mode, initialSelected, onConfirm, onClose }) {
  const [selected, setSelected] = useState(initialSelected || [])

  const isInclude = mode === 'include'
  const headerBg = isInclude
    ? 'bg-emerald-50 dark:bg-emerald-900/30 border-emerald-300 dark:border-emerald-700'
    : 'bg-rose-50 dark:bg-rose-900/30 border-rose-300 dark:border-rose-700'
  const headerText = isInclude ? 'text-emerald-800 dark:text-emerald-200' : 'text-rose-800 dark:text-rose-200'
  const title = isInclude ? '🚩 Incluir Flag' : '🚩 Excluir Flag'
  const subtitle = isInclude
    ? 'Los contactos deben tener una de estas banderas para aparecer'
    : 'Los contactos con cualquiera de estas banderas NO aparecerán'
  const selectedBorder = isInclude
    ? 'border-emerald-500 dark:border-emerald-400 bg-emerald-50 dark:bg-emerald-900/30'
    : 'border-rose-500 dark:border-rose-400 bg-rose-50 dark:bg-rose-900/30'

  const toggle = (key) => {
    setSelected(prev => prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key])
  }

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center" onClick={onClose}>
      <div
        className="bg-white dark:bg-gray-800 rounded-lg w-96 max-w-full max-h-[90vh] flex flex-col"
        onClick={e => e.stopPropagation()}
      >
        <div className={`p-4 border-b rounded-t-lg ${headerBg}`}>
          <h3 className={`text-base font-semibold ${headerText}`}>{title}</h3>
          <p className={`text-xs mt-1 ${headerText} opacity-80`}>{subtitle}</p>
        </div>

        <div className="flex-1 overflow-y-auto p-4">
          <div className="grid grid-cols-3 gap-2">
            {FLAG_OPTIONS.map(opt => {
              const isSel = selected.includes(opt.key)
              return (
                <button
                  key={opt.key}
                  onClick={() => toggle(opt.key)}
                  type="button"
                  title={opt.label}
                  className={`flex flex-col items-center justify-center p-3 rounded-lg border-2 transition-colors ${
                    isSel
                      ? selectedBorder
                      : 'border-gray-200 dark:border-gray-700 hover:border-gray-400 dark:hover:border-gray-500'
                  }`}
                >
                  <span className="flex items-center justify-center" style={{ minHeight: '2rem' }}>
                    {opt.render('lg')}
                  </span>
                  <span className="text-xs mt-1 text-gray-700 dark:text-gray-300">{opt.label}</span>
                </button>
              )
            })}
          </div>
        </div>

        <div className="flex justify-between items-center px-4 py-3 border-t border-gray-200 dark:border-gray-700">
          <span className="text-xs text-gray-500 dark:text-gray-400">
            {selected.length} seleccionada{selected.length !== 1 ? 's' : ''}
          </span>
          <div className="flex gap-2">
            <button
              onClick={onClose}
              type="button"
              className="px-4 py-2 text-sm text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded"
            >
              Cancelar
            </button>
            <button
              onClick={() => { onConfirm(selected); onClose() }}
              type="button"
              className="px-4 py-2 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
